<template>
  <div>
    <px-minha-empresa-filiais-lista :empresas="empresas"
                                    :loading="loading"
                                    :public-file-path="publicFilePath"
                                    :on-change-options="onChangeOptions"
                                    :has-role-gestor-compras="hasRoleGestorCompras"
                                    @update-logo="updateLogoEmpresa"
                                    @update-faturamento="updateEmpresaFaturamentoPadrao"
                                    @update-entrega="updateEmpresaEntregaPadrao"
                                    @update-locais-entrega="updateLocaisEntrega"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import CompradorService from '@/api/comprador-service';
import MinhaEmpresaFiliaisLista from '../listagem/MinhaEmpresaFiliaisLista.vue';

export default {
  props: {
    publicFilePath: String,
  },
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      empresas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: 'order by nome',
        sort: '',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleGestorCompras']),
    ...mapGetters('entidade', ['entidade']),
  },
  methods: {
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCompradores();
    },
    buildPayload(empresa) {
      return {
        id: empresa.id,
        logoComprador: empresa.logoComprador,
        filialFaturamentoPadrao: empresa.filialFaturamentoPadrao,
        filialEntregaPadrao: empresa.filialEntregaPadrao,
        locaisEntrega: empresa.locaisEntrega ?? null,
      };
    },
    updateEmpresaFaturamentoPadrao(empresa) {
      this.loading = true;

      CompradorService.updateFilialFaturamento(this.buildPayload(empresa))
        .then(() => {
          this.$toast('Filial de faturamento padrão atualizada', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
          this.getCompradores();
        });
    },
    updateEmpresaEntregaPadrao(empresa) {
      this.loading = true;

      CompradorService.updateFilialEntrega(this.buildPayload(empresa))
        .then(() => {
          this.$toast('Filial de entrega padrão atualizada', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
          this.getCompradores();
        });
    },
    updateLogoEmpresa(empresa) {
      this.loading = true;

      CompradorService.updateLogoFilial(this.buildPayload(empresa))
        .then(() => {
          this.$toast('Logo da filial atualizada', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateLocaisEntrega(empresa) {
      this.loading = true;

      CompradorService.updateLocaisEntrega(this.buildPayload(empresa))
        .then(() => {
          this.$toast('Local de entrega atualizado', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCompradores() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      CompradorService.getCompradorPage({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.empresas = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxMinhaEmpresaFiliaisLista: MinhaEmpresaFiliaisLista,
  },
};
</script>
